module.exports = __webpack_public_path__ + "static/media/add.887c8461.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assert/images/add.svg
// module id = 3227
// module chunks = 1